import { gdprFieldsData } from 'src/components/Forms/GdprFields/gdprFieldsData';
import { cta as thanksPageCta } from 'src/store/contact-thanks';
import { formData } from 'src/store/form';
import type { FlowStep } from './contact-routing-reducer';

export const contactRoutingConfig = {
  flag: {
    key: '04-contact-routing',
    variant: 'routing',
    control: 'control',
    controlPagePath: '/contact/',
    optOutParam: 'contact-routing',
    testModeParam: 'test_mode',
    eligibilityTimeoutMs: 2000,
  },
  dashboardSignupUrl: 'https://dashboard.plaid.com/signup',
  showDashboardLinks: false,
  analytics: {
    trackingId: 'CONTACT_ROUTING',
    formType: 'CONTACT_ROUTING',
    locale: 'en-us',
  },
  chrome: {
    homeUrl: '/',
    guillocheImage:
      'https://images.ctfassets.net/ss5kfr270og3/6DeHbi58gBFCWyi0JWKjso/b5c810395bfd63994fc74373a80b76c6/guilloche-wave_2x.webp',
    trustedByLogos: [
      {
        name: 'Acorns',
        image:
          'https://images.ctfassets.net/ss5kfr270og3/1rlLh0NefPjsnhxiRCosLo/f205dbe8e768d9fb0db7bcc2d4cd50a0/logo-acorns_2x.png',
      },
      {
        name: 'Affirm',
        image:
          'https://images.ctfassets.net/ss5kfr270og3/bkLxcGxGvdqTqs8rdcniM/6d285c2d77e0c40aa49f2248d2a4e176/logo-affirm_2x.png',
      },
      {
        name: 'Cash App',
        image:
          'https://images.ctfassets.net/ss5kfr270og3/79vMqlxrgCRO3OPFdKjS7L/7272c5333e51c262b4f500a8c50d0ac7/logo-cash-app_2x.png',
      },
      {
        name: 'Robinhood',
        image:
          'https://images.ctfassets.net/ss5kfr270og3/24Mrjo5QFMJE7Rx9akcLrq/fc991308046bb326d6010905aba2fbbf/logo-robinhood_2x.png',
      },
      {
        name: 'Shopify',
        image:
          'https://images.ctfassets.net/ss5kfr270og3/48ODGHVOsOy5L0RSQlxluL/d6aed9501a099123bccf29c57433d86d/logo-shopify_2x.png',
      },
    ],
    progress: {
      email: 33,
      form: 67,
      received: 100,
    } satisfies Record<FlowStep, number>,
  },
  stateRequiredFor: 'United States',
  defaultCountry: 'United States',
  privacyUrl: '/legal/#privacy-statement',
  consumerHelpUrl: 'https://support-my.plaid.com/hc/en-us',
  dashboardSupportUrl: 'https://dashboard.plaid.com/support/new',
  implementationGuide: thanksPageCta,
  copy: {
    emailHeading: 'Let’s get you to',
    emailHeadingHighlight: 'the right team',
    workEmailLabel: 'Work email',
    countryLabel: gdprFieldsData.country.label,
    stateLabel: gdprFieldsData.state.label,
    marketingOptInHtml: gdprFieldsData.optInLabel,
    continueLabel: 'Continue',
    createAccountPrompt: 'Want to start testing?',
    createAccountLabel: 'Create account instead',
    invalidEmailMessage: 'Enter a valid email address',
    formHeading: 'Tell us about',
    formHeadingHighlight: 'yourself',
    firstNameLabel: 'First name',
    lastNameLabel: 'Last name',
    phoneLabel: formData.phone.label,
    companyLabel: 'Company name',
    notesLabel:
      'Describe what you are building and how can we help? Details are helpful.',
    selectPrompt: 'Select one',
    requiredMessage: 'Required',
    submitLabel: 'Submit',
    disclaimerText:
      'By submitting this form, I confirm that I have read and understood Plaid’s',
    disclaimerLink: 'Privacy Statement',
    supportIntro:
      'This form goes to our sales team. For help connecting your financial accounts to a Plaid-powered app, visit our',
    supportConsumerLink: 'consumer help center',
    supportDashboardIntro:
      'For developers and existing Plaid customers, please open a case through the',
    supportDashboardLink: 'Plaid Dashboard',
    homeLinkLabel: 'Plaid home',
    progressLabel: 'Progress',
    trustedByLabel: 'Trusted by',
    receivedHeading: 'Request received',
    receivedCopy:
      'Your message has been sent. A member of our team will be in touch soon.',
    createAccountCopy: 'You can start building with a Dashboard account.',
    createAccountButton: 'Create account',
  },
} as const;
